'use strict';

/**
 * Configuration file for Search Filter Form
 * Centralizes all constants, element selectors, and CSS classes
 */
export const CONFIG = {
	// Element selectors for DOM queries
	ELEMENTS: {
		checkboxSingleSelect: '[data-search-filter-form-single-select]',
		closeButton: '[data-search-filter-form-close-button]',
		deselectButton: '[data-search-filter-form-deselect-button]',
		dropdown: '[data-search-filter-form-dropdown]',
		dropdownModal: '[data-search-filter-form-dropdown-modal]',
		form: '[data-search-filter-form]',
		input: '[data-search-filter-form-input]',
		label: '[data-search-filter-form-label]',
		modalTrigger: '[data-search-filter-form-modal-trigger]',
		option: '[data-search-filter-form-option]',
		searchInput: '[data-search-filter-form-search-input]',
		tabbedOption: '[data-search-filter-form-tabbed-option]',
		validationMessage: '[data-search-filter-form-validation-message]',
	},

	// CSS classes for styling and state management
	CSS_CLASSES: {
		dropdownError: 'gt-form-dropdown--error',
		modalActive: 'gt-form-modal--active',
		multiSelectInput: 'gt-form-input--multi-select',
		optionHidden: 'gt-form-input-wrapper--hidden',
		optionSelected: 'gt-form-input-wrapper--selected',
	},
};
